<template lang="pug">
section
    h4(style='font-weight: 800; color: #5a5a5a; margin-bottom: 10px') {{ $t('mensagens.territorio.territorioAr.persona.titulo') }}
    el-card
        el-form(
            label-position='top',
            :model='form',
            :rules='rules',
            ref='ruleForm'
        )
            el-row(
                style='margin-right: 10px',
                align='bottom',
                justify='space-between',
                type='flex',
                :gutter='20'
            )
                el-col(:span='12')
                    el-form-item(
                        style='width: 100%',
                        prop='pessoa',
                        :label='$t("mensagens.territorio.territorioAr.persona.persona")'
                    )
                        el-select(
                            style='width: 100%',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            v-model='form.pessoa'
                        )
                            el-option(
                                :value='item.id',
                                :label='item.nomeRazaoSocial',
                                :key='item.id',
                                value-key='id',
                                v-for='(item, index) in representantes'
                            )
                el-col(:span='12')
                    el-form-item(
                        prop='papel',
                        :label='$t("mensagens.territorio.territorioAr.persona.papel")'
                    )
                        .flex
                            el-select(
                                style='width: 100%',
                                :placeholder='$t("mensagens.comuns.selecione")',
                                v-model='form.papel'
                            )
                                el-option(
                                    :value='item.id',
                                    :label='item.nome',
                                    :key='item.id',
                                    value-key='id',
                                    v-for='(item, index) in papeis'
                                )
                            el-button(
                                @click='addInformation("ruleForm")',
                                style='margin-bottom: 0px; margin-left: 15px',
                                type='primary',
                                icon='el-icon-circle-plus-outline'
                            )

        el-divider
        div(v-if='options.length > 0')
            el-row.list(
                type='flex',
                :key='index',
                v-for='(item, index) in options'
            )
                el-col
                    label
                        | {{
                        |
                        | $t('mensagens.territorio.territorioAr.persona.persona')
                        |
                        | }}
                        dl {{ item.pessoa?.nome }}
                el-col
                    label
                        | {{
                        |
                        | 'CUIT'
                        |
                        | }}
                        dl {{ formatCuit(item.pessoa?.documento) }}
                el-col
                    label
                        | {{
                        |
                        | $t('mensagens.territorio.territorioAr.persona.papel')
                        |
                        | }}
                        dl {{ item.papel?.nome }}

                el-col(:span='1')
                    el-button(
                        @click='deleteInformation(index)',
                        style='margin: 0px 16px; color: #dc362e',
                        type='text',
                        icon='el-icon-delete'
                    )
        div(v-else)
            h4.text-center {{ $t('mensagens.territorio.territorioAr.persona.mensagem') }}
</template>
<script>
import formatters from '@/utils/formatters';

export default {
    data() {
        return {
            form: { pessoa: null, papel: null },
            rules: {
                pessoa: [
                    {
                        required: true,
                        message: this.$t(
                            'mensagens.territorio.preenchaCampoObrigatorio'
                        ),
                        trigger: ['blur', 'change']
                    }
                ],
                papel: [
                    {
                        required: true,
                        message: this.$t(
                            'mensagens.territorio.preenchaCampoObrigatorio'
                        ),
                        trigger: ['blur', 'change']
                    }
                ]
            }
        };
    },
    props: {
        representantes: {
            type: Array,
            default: () => []
        },
        papeis: {
            type: Array,
            default: () => []
        },
        options: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        addInformation(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    const params = {
                        pessoa: {
                            nome: this.representantes.find(
                                item => item.id === this.form.pessoa
                            ).nomeRazaoSocial,
                            documento: this.representantes.find(
                                item => item.id === this.form.pessoa
                            ).documento,
                            id: this.form.pessoa
                        },
                        papel: {
                            nome: this.papeis.find(
                                item => item.id === this.form.papel
                            ).nome,
                            id: this.form.papel
                        }
                    };

                    this.$emit('update', params);
                    this.$refs[formName].resetFields();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        deleteInformation(index) {
            this.$emit('delete', index);
        },
        formatCuit(documento) {
            return formatters.formatarCuit(documento);
        }
    }
};
</script>
<style scoped lang="scss">
.list {
    text-align: left;
    background: #f5f5f5;
    border-radius: 4px;
    padding: 5px 15px;
    margin-top: 5px;

    label {
        color: #183b57;
        font-weight: 500;
    }

    dl {
        color: #3b3b3b;
        font-weight: 600;
        margin-bottom: 0px !important;
    }
}
</style>
